import { CLONE_PROFILE_PATH, LEGACY_CLONE_PROFILE_PATH } from './constants';

function matchesPath(pathname: string, base: string): boolean {
  return pathname === base || pathname.startsWith(`${base}/`);
}

export function isCloneProfilePath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return matchesPath(pathname, CLONE_PROFILE_PATH) || matchesPath(pathname, LEGACY_CLONE_PROFILE_PATH);
}

/** Logged-in visitors get dashboard sidebar/header on clone pages; iframe embeds (`videomode=true`) stay bare. */
export function shouldShowCloneDashboardChrome(
  pathname: string | null | undefined,
  isAuthenticated: boolean,
  isVideomodeEmbed: boolean
): boolean {
  return isCloneProfilePath(pathname) && isAuthenticated && !isVideomodeEmbed;
}

export function rewriteTalentPathToUser(cloneUrl: string | undefined): string {
  if (!cloneUrl?.trim()) return '';

  try {
    const url = new URL(cloneUrl);
    if (matchesPath(url.pathname, LEGACY_CLONE_PROFILE_PATH)) {
      url.pathname = `${CLONE_PROFILE_PATH}${url.pathname.slice(LEGACY_CLONE_PROFILE_PATH.length)}`;
    }
    return url.toString();
  } catch {
    if (cloneUrl === LEGACY_CLONE_PROFILE_PATH || cloneUrl.startsWith(`${LEGACY_CLONE_PROFILE_PATH}/`) || cloneUrl.startsWith(`${LEGACY_CLONE_PROFILE_PATH}?`)) {
      return `${CLONE_PROFILE_PATH}${cloneUrl.slice(LEGACY_CLONE_PROFILE_PATH.length)}`;
    }
    return cloneUrl;
  }
}
